/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Nav from './nav';
import { frontUrl } from '../helper/constants';
interface HeaderHomeProps {
  data: any | ""; // you can replace `any` with a proper type if you know the shape
  loading: boolean | false;
}
const HeaderCome: React.FC<HeaderHomeProps> = ({ data, loading }: any) => {
  if (loading) return <p>Loading...</p>;
  // if (error) return <p>Error: {error}</p>;
  // if (!data) return <p>No data found.</p>;
  const imgurl = frontUrl;
 // Extract URL safely
  const custaurl = data?.field_link_url?.[1]?.uri ? data?.field_link_url?.[1]?.uri?.replace('internal:', '')?.trim() : "#";

  return (
    
   <header id="header" className="header d-flex align-items-center fixed-top bg-light">
        <div className="container-fluid container-xl position-relative d-md-flex  align-items-center justify-content-between">

            <a href="/" className="logo d-flex float-sm-start align-items-center">
              
                {/* <img src="assets/img/gro-logo-blue.png" alt="gro" className=" " /> */}
              <img src={`${imgurl}assets/img/gro-logo-blue.png`} alt="gro" className="" />
            </a>

       <Nav data={data} loading={loading}  />
          {/* <a className="btn btn-md btn-success d-lg-block d-md-none btn-login d-sm-none" target='_black' href={custaurl} title={custaurl} >{data?.field_link_url?.[1]?.title ? data?.field_link_url?.[1]?.title : ''}</a> */}
      {/* <a className="btn btn-md btn-success d-none" target='_black' href={custaurl} title={custaurl} >{data?.field_link_url?.[1]?.title ? data?.field_link_url?.[1]?.title : ''}</a> */}
      </div>
  </header>

);
};

export default HeaderCome;